<template>
  <Dialog v-model="show" :title="$t('Clientes que cumplen años hoy')">
    <template v-slot:content>
      <v-container fluid>
        <v-data-table
          :headers="tabla.headers"
          :items="tabla.items"
          :options.sync="tabla.options"
          :server-items-length="tabla.total"
          :fixed-header="true"
          class="elevation-3"
          calculate-widths
          :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: 'Registros por página' }"
          :no-data-text="$t('No hay datos')"
          :no-results-text="$t('No hay datos')"
          hide-default-footer
        >
          <template v-slot:item="{ item }">
            <tr @click="$router.push({name: 'ficha_cliente', params: {id: item.id}}); show=false">
              <td>
                <v-img
                    :src="item.foto_url_absolute_path"
                    :alt="item.nombre"
                    :title="item.nombre"
                    max-width="50"
                    max-height="50"
                    contain
                />
              </td>
              <td>{{ item.nombre }}</td>
              <td>{{ item.apellido1 }}</td>
              <td>{{ item.apellido2 }}</td>
              <td>{{ item.fecha_nacimiento | moment("from", true) }}</td>
              <td>
                <div :class="{'blurred': $store.state.auth.user.tipo_empleado !== 'admin' && !$store.getters['auth/has_permission']('ver_movil_cliente')}">
                  {{ item.movil }}
                </div>
              </td>
              <td>
                <div :class="{'blurred': $store.state.auth.user.tipo_empleado !== 'admin' && !$store.getters['auth/has_permission']('ver_fijo_cliente')}">
                  {{ item.fijo }}
                </div>
              </td>
              <td>
                <div :class="{'blurred': $store.state.auth.user.tipo_empleado !== 'admin' && !$store.getters['auth/has_permission']('ver_email_cliente')}">
                  {{ item.email }}
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </template>
  </Dialog>
</template>

<script>
import useTable from "@/composables/useTable"
import router from "@/router";
export default {
  name: "DialogCumplesClientes",
  methods: {
    router() {
      return router
    }
  },

  setup(props, {root}) {

    const {tabla, get_items} = useTable("centro/get_cumpleanios")

    const get_cumples= async () => get_items(props['selected_filters'])
    get_cumples()

    tabla.value.headers = [
      { text: '', value: 'foto_url_absolute_path', class: "primary white--text", sortable: false },
      { text: root.$t('Nombre'), value: 'nombre', class: "primary white--text", sortable: false },
      { text: root.$t('Primer apellido'), value: 'apellido1', class: "primary white--text", sortable: false },
      { text: root.$t('Segundo apellido'), value: 'apellido2', class: "primary white--text", sortable: false },
      { text: root.$t('Edad'), value: 'fecha_nacimiento', class: "primary white--text", sortable: false },
      { text: root.$t('Teléfono móvil'), value: 'movil', class: "primary white--text", sortable: false },
      { text: root.$t('Teléfono fijo'), value: 'fijo', class: "primary white--text", sortable: false },
      { text: root.$t('Email'), value: 'email', class: "primary white--text", sortable: false },
    ]

    return {
      tabla,
      get_cumples,
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
}
</script>

<style scoped>
.blurred {
  -webkit-filter: blur(3px);
  filter: blur(3px);
}
</style>
